module.exports = __webpack_public_path__ + "img/planet-with-no-star.7b7e649e.jpg";